import { Chip } from '@mui/material'
import React, { ReactElement } from 'react'
import { FunctionField, useTranslate } from "react-admin"
import get from 'lodash/get'

interface ChipifyProps {
  variant: "squere-chip" | "big-chip";
  translation?: string;
  source: string | string[];
  subsource?: string
  renderIcon?: (value: string, row?: any) => ReactElement | undefined;
  disable?: (value: string, row?: any) => boolean;
  exclude?: string[];
  label?: string;
  fallbackChipLabel?: string;
  sortable?: boolean;
}

const getValue = (item: any, subsource?: string) =>
  typeof item === 'object' && subsource ? item[subsource] : item

const filterExcluded = (items: any[], exclude?: string[], subsource?: string) =>
  exclude ? items.filter((item) => !exclude.includes(getValue(item, subsource))) : items

export const Chipify = ({
  variant,
  translation,
  source,
  subsource,
  renderIcon = () => undefined,
  disable = () => false,
  exclude,
  fallbackChipLabel
}: ChipifyProps) => {
  const translate = useTranslate()

  const renderChip = (value: string, row?: any) => (
    <Chip
      key={value}
      className={variant}
      label={(translation && translate(`${translation}${value}`)) || value}
      icon={renderIcon(value, row)}
      disabled={disable(value, row)}
    />
  )

  const fallbackChip = fallbackChipLabel ? (
    <Chip key={fallbackChipLabel} className={variant} label={fallbackChipLabel} />
  ) : null

  const toChips = (record?: any) => {
    if (typeof source === 'string') {
      const value = get(record, source)
      if (typeof value === 'string') {
        return exclude?.includes(value) ? null : renderChip(value, record)
      }
      if (Array.isArray(value)) {
        const filtered = filterExcluded(value, exclude, subsource)
        const chips = filtered.map((item) => renderChip(getValue(item, subsource), record))
        return chips.length > 0 ? chips : fallbackChip
      }
      return fallbackChip
    }
    return renderChip(record as string, undefined)
  }

  if (typeof source === 'string') {
    return <FunctionField source={source} render={toChips} />
  }
  const items = filterExcluded(source, exclude, subsource)
  return <>{items.map(toChips)}</>
}